import { IFontManagerInjectable, IFontsUsingStatus } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

export class FontManagerInjectable implements IFontManagerInjectable {
    public disableUncommonFontLogic = false;

    public get disableVip(): boolean {
        return !(appConfigInstance.getConfig('custom.vip') ?? true);
    }

    public get disableCloudFont(): boolean {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.cloudFont as any) ?? true);
    }

    public get injectedFontUsingStatus(): IFontsUsingStatus | undefined {
        return undefined;
    }
}
